/* global System */

export default {
  WertErmittler: () =>
    System.import(/* webpackChunkName: "WertErmittler" */ './index'),
}
